import { useContext } from 'react';

import { BulletinBoardContext } from '../../../bulletinBoardContext';

import { BulletinList } from './bulletinList';
import { EmptyList } from './emptyList';
import { LoadingList } from './loadingList';

export function BulletinSettings(): JSX.Element {
  const bulletinAPI = useContext(BulletinBoardContext);

  if (!bulletinAPI) {
    throw new Error('Bulletin context not found');
  }

  const {
    hasReadError,
    isFetching,
    isUpdating,
    bulletins,
    canAddMore,
    onDelete,
    onEdit,
    setEnabled,
    onAdd,
    onReorder,
  } = bulletinAPI;

  if (hasReadError || isFetching) {
    return <LoadingList />;
  }
  if (!bulletins || bulletins.length === 0) {
    return <EmptyList onAdd={onAdd} isUpdating={isUpdating} />;
  }
  return (
    <BulletinList
      isUpdating={isUpdating}
      bulletins={bulletins}
      canAddMore={canAddMore}
      onDelete={onDelete}
      onEdit={onEdit}
      setEnabled={setEnabled}
      onAdd={onAdd}
      onReorder={onReorder}
    />
  );
}
